const ALLOWED_EXTERNAL_REDIRECT_HOSTS = [
  /(^|\.)pesapal\.com$/i,
  /(^|\.)flutterwave\.com$/i,
  /(^|\.)mpesa/i,
  /(^|\.)safaricom\.co\.ke$/i,
];

const isAllowedExternalHost = (hostname: string) =>
  ALLOWED_EXTERNAL_REDIRECT_HOSTS.some((pattern) => pattern.test(hostname));

export const navigateToTrustedRedirect = (rawUrl: unknown): boolean => {
  if (typeof rawUrl !== 'string' || !rawUrl.trim()) return false;

  let parsed: URL;
  try {
    parsed = new URL(rawUrl, window.location.origin);
  } catch {
    return false;
  }

  if (parsed.origin === window.location.origin) {
    window.location.assign(parsed.href);
    return true;
  }

  if (parsed.protocol !== 'https:') return false;
  if (!isAllowedExternalHost(parsed.hostname)) return false;

  window.location.assign(parsed.href);
  return true;
};
